import React from 'react';
import '../less/miniCasco.less';
import FAQStorybook from '@abank/abank-faq';
import advantages_img_1 from '../img/advantages_img_1.png';
import advantages_img_2 from '../img/advantages_img_2.png';
import advantages_img_3 from '../img/advantages_img_3.png';
import QuestionsAdminNew from '../../../../../auxiliary-components/shared/QuestionsAdminNew';
import hero_img from '../img/hero_img.png';
import Hero from '../../../../../auxiliary-components/shared/HeroBlock';
import Tariffs from '../../../../../auxiliary-components/shared/TariffsBlock';
import advantagesItemsData from '../enums/advantages_items.json';
import AdditionalProduct from '../../../../../auxiliary-components/shared/AdditionalProductBlock';
import additionalCards from '../enums/additional_cards_data.json';
import QuestionsFullAdmin from '../../../../../auxiliary-components/shared/QuestionsFullAdmin';
import insurerInfoDataConfig from '../enums/insurer_info_data.json';
import intermediaryTariffsData from '../enums/intermediary_tariffs_data.json';
import Tabs from '../../../../../auxiliary-components/shared/Tabs';
import mini_casco_img from '../img/mini_casco_img.png';
import { insuranceDocumentsArxCompanyLink, insuranceDocumentsEuroinsCompanyLink, insuranceDocumentsUniqaCompanyLink, insuranceDocumentsUniversalnaCompanyLink, insuranceDocumentsVusoCompanyLink, insuranceIntermediaryInfoArsenalLink, insuranceIntermediaryInfoArxlifeLink, insuranceIntermediaryInfoArxLink, insuranceIntermediaryInfoEiaLink, insuranceIntermediaryInfoEuroinsLink, insuranceIntermediaryInfoEurotravelinsLink, insuranceIntermediaryInfoIngoLink, insuranceIntermediaryInfoInterexpressLink, insuranceIntermediaryInfoInterpolicyLink, insuranceIntermediaryInfoKniazhaLink, insuranceIntermediaryInfoOrantaLink, insuranceIntermediaryInfoPzuLink, insuranceIntermediaryInfoRespectinsLink, insuranceIntermediaryInfoSgtasLink, insuranceIntermediaryInfoTaslifeLink, insuranceIntermediaryInfoUkringroupLink, insuranceIntermediaryInfoUniqaLink, insuranceIntermediaryInfoUniversalnaLink,insuranceIntermediaryInfoUticoLink, insuranceIntermediaryInfoVusoLink, insuranceMiniCascoDocumentsArxProductLink, insuranceMiniCascoDocumentsEuroinsProductLink, insuranceMiniCascoDocumentsUniqaProductLink, insuranceMiniCascoDocumentsUniversalnaProductLink, insuranceMiniCascoDocumentsVusoProductLink } from '../../../../../services/urls/urls';
import { Preloader } from 'MWComponents';
import intermediaryInfoDataConfig from '../enums/intermediary_info_data.json';
import InsuranceIntermediaryInfo from '../../../../../auxiliary-components/shared/InsuranceIntermediaryInfo';
import Advantages from '../../../../../auxiliary-components/shared/AdvantagesBlock';
import { mapInsuranceDetailedInfoToTariffs } from '../../../../../helpers/utils/mapInsuranceDetailedInfoToTariffs';
import { ReactSVG } from 'react-svg';
import attention_icon from '../img/attention_icon.svg';
import { filterByEnvironment } from '../../../../../helpers/utils/environmentFilter';
import { canUseDOM } from '../../../../../helpers/canUseDOM';

export default function template() {
  const page = "mini-casco-new";

  const tabs = [{tab: 'insurer-info', title: 'MINI_CASCO_NEW_TABS_TITLE_01'},
        {tab: 'partners', title: 'MINI_CASCO_NEW_TABS_TITLE_02'},
        {tab: 'insurance-info', title: 'MINI_CASCO_NEW_TABS_TITLE_03'},
        {tab: 'intermediary-info', title: 'MINI_CASCO_NEW_TABS_TITLE_04'}];

  const tabsShortInsuranceInfo= [{tab: 'vuso-short', title: 'MINI_CASCO_NEW_TABS_INSURANCE_INFO_TITLE_01'},
        {tab: 'evroins-short', title: 'MINI_CASCO_NEW_TABS_INSURANCE_INFO_TITLE_02'},
        {tab: 'uniqa-short', title: 'MINI_CASCO_NEW_TABS_INSURANCE_INFO_TITLE_03'},
        {tab: 'arx-short', title: 'MINI_CASCO_NEW_TABS_INSURANCE_INFO_TITLE_04'},
        {tab: 'univers-short', title: 'MINI_CASCO_NEW_TABS_INSURANCE_INFO_TITLE_05'}]

  const tabsFullInsuranceInfo = [{tab: 'vuso-full', title: 'MINI_CASCO_NEW_TABS_INSURANCE_INFO_TITLE_01'},
        {tab: 'evroins-full', title: 'MINI_CASCO_NEW_TABS_INSURANCE_INFO_TITLE_02'},
        {tab: 'uniqa-full', title: 'MINI_CASCO_NEW_TABS_INSURANCE_INFO_TITLE_03'},
        {tab: 'arx-full', title: 'MINI_CASCO_NEW_TABS_INSURANCE_INFO_TITLE_04'},
        {tab: 'univers-full', title: 'MINI_CASCO_NEW_TABS_INSURANCE_INFO_TITLE_05'}];

  const imagesMap = {
    advantages_img_1,
    advantages_img_2,
    advantages_img_3
  };

  const linksMap = { insuranceIntermediaryInfoArxLink, insuranceIntermediaryInfoVusoLink, insuranceIntermediaryInfoUniversalnaLink, insuranceIntermediaryInfoUniqaLink, insuranceIntermediaryInfoEiaLink, insuranceIntermediaryInfoEurotravelinsLink, insuranceIntermediaryInfoArsenalLink, insuranceIntermediaryInfoEuroinsLink, insuranceIntermediaryInfoIngoLink, insuranceIntermediaryInfoInterexpressLink, insuranceIntermediaryInfoInterpolicyLink, insuranceIntermediaryInfoOrantaLink, insuranceIntermediaryInfoPzuLink, insuranceIntermediaryInfoRespectinsLink, insuranceIntermediaryInfoSgtasLink, insuranceIntermediaryInfoUkringroupLink, insuranceIntermediaryInfoUticoLink, insuranceIntermediaryInfoArxlifeLink, insuranceIntermediaryInfoKniazhaLink, insuranceIntermediaryInfoTaslifeLink, insuranceDocumentsVusoCompanyLink, insuranceDocumentsUniversalnaCompanyLink, insuranceDocumentsEuroinsCompanyLink, insuranceDocumentsUniqaCompanyLink, insuranceDocumentsArxCompanyLink, insuranceMiniCascoDocumentsArxProductLink, insuranceMiniCascoDocumentsUniqaProductLink, insuranceMiniCascoDocumentsEuroinsProductLink, insuranceMiniCascoDocumentsUniversalnaProductLink, insuranceMiniCascoDocumentsVusoProductLink };

  const intermediaryInfoData = intermediaryInfoDataConfig.map(item => {
    if (item.type === 'companies' && item.companies) {
      return {
        ...item,
        companies: item.companies.map(company => ({
          ...company,
          link: linksMap[company.link]
        }))
      };
    }
    return {
      ...item
    };
  });

  const insurerInfoData = insurerInfoDataConfig.map(item => ({
    ...item,
    values: item.values.map(val => {
      if (val.type === 'button') {
        return {
          ...val,
          btnLink: linksMap[val.btnLink],
        };
      }

      return val;
    })
  }));

  const hero_data = {
    title: "MINI_CASCO_NEW_HERO_TITLE",
    text: "MINI_CASCO_NEW_HERO_TEXT"
  }

  const advantagesItems = advantagesItemsData.map(item => ({
    ...item,
    img: imagesMap[item.img]
  }));

  const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');
  const partnersWidget = this.widgetsHelper.getWidget.call(this, 'partners');

  const detailedInsuranceInfoWidgets = [
    {widget: this.widgetsHelper.getWidgetFrom.call(this, 'detailedInfoVusoWidget', 'questions'), loadingKey: 'detailedInfoVusoWidget_loading'},
    {widget: this.widgetsHelper.getWidgetFrom.call(this, 'detailedInfoEvroinsWidget', 'questions'), loadingKey: 'detailedInfoEvroinsWidget_loading'},
    {widget: this.widgetsHelper.getWidgetFrom.call(this, 'detailedInfoUniqaWidget', 'questions'), loadingKey: 'detailedInfoUniqaWidget_loading'},
    {widget: this.widgetsHelper.getWidgetFrom.call(this, 'detailedInfoArxWidget', 'questions'), loadingKey: 'detailedInfoArxWidget_loading'},
    {widget: this.widgetsHelper.getWidgetFrom.call(this, 'detailedInfoUniversWidget', 'questions'), loadingKey: 'detailedInfoUniversWidget_loading'}
  ];

  return (
    <div className="mini-casco-new">
      <Hero
        data={hero_data}
        img={hero_img}
      />
      <div className={`content${(this.state.faqTab || this.state.detailedInsuranceInfoTab || this.state.intermediaryInsuranceInfoTab) ? ' hidden' : ''}`}>
        <div className="general-info">
          <div className="container">
            <div className="general-info__body">
              <div className="general-info__image">
                <img src={mini_casco_img} alt="general info image" />
              </div>
              <div className="general-info__left">
                <div className="general-info__top top-general-info">
                  <h2 className="general-info__title">{this.l10n('MINI_CASCO_NEW_GENERAL_INFO_TOP_TITLE')}</h2>
                  <div className="top-general-info__text">
                    <p>{this.l10n('MINI_CASCO_NEW_GENERAL_INFO_TOP_TEXT')}</p>
                    <ul>
                      <li>{this.l10n('MINI_CASCO_NEW_GENERAL_INFO_TOP_LIST_01')}</li>
                      <li>{this.l10n('MINI_CASCO_NEW_GENERAL_INFO_TOP_LIST_02')}</li>
                      <li>{this.l10n('MINI_CASCO_NEW_GENERAL_INFO_TOP_LIST_03')}</li>
                    </ul>
                  </div>
                </div>
                <div className="general-info__conditions conditions">
                  <h2 className="general-info__title">{this.l10n('MINI_CASCO_NEW_CONDITIONS_TITLE')}</h2>
                  <div className="conditions__items">
                    <div className="conditions__item item-conditions">
                      <h3 className="item-conditions__title">{this.l10n('MINI_CASCO_NEW_CONDITIONS_ITEM_TITLE_01')}</h3>
                      <div className="item-conditions__text">{this.l10n('MINI_CASCO_NEW_CONDITIONS_ITEM_TEXT_01')}</div>
                    </div>
                    <div className="conditions__item item-conditions">
                      <h3 className="item-conditions__title">{this.l10n('MINI_CASCO_NEW_CONDITIONS_ITEM_TITLE_02')}</h3>
                      <div className="item-conditions__text">{this.l10n('MINI_CASCO_NEW_CONDITIONS_ITEM_TEXT_02')}</div>
                    </div>
                    <div className="conditions__item item-conditions">
                      <h3 className="item-conditions__title">{this.l10n('MINI_CASCO_NEW_CONDITIONS_ITEM_TITLE_03')}</h3>
                      <div className="item-conditions__text">{this.l10n('MINI_CASCO_NEW_CONDITIONS_ITEM_TEXT_03')}</div>
                    </div>
                  </div>
                </div>
                <div className="general-info__attention attention">
                  <div className="attention__title">
                    <ReactSVG src={attention_icon} className="attention icon"/>
                    {this.l10n('MINI_CASCO_NEW_ATTENTION_TITLE')}
                  </div>
                  <div className="attention__text">
                    <ul>
                      <li>{this.l10n('MINI_CASCO_NEW_ATTENTION_LIST_01')}</li>
                      <li>{this.l10n('MINI_CASCO_NEW_ATTENTION_LIST_02')}</li>
                      <li>{this.l10n('MINI_CASCO_NEW_ATTENTION_LIST_03')}</li>
                      <li>{this.l10n('MINI_CASCO_NEW_ATTENTION_LIST_04')}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Advantages
          items={advantagesItems}
          title={'MINI_CASCO_NEW_ADVANTAGES_TITLE'}
        />
        <Tabs tabs={tabs} toggle={this.toggleTab} tab={this.state.tab} page={page}>
          <Tariffs
            items={insurerInfoData}
            title={'MINI_CASCO_NEW_TARIFFS_INSURER_INFO_TITLE'}
            page={page}
            titleTag={"div"}
          />
          {this.state.loader ? (canUseDOM ? <Preloader/> : null) : (partnersWidget && partnersWidget.data && partnersWidget.data.length > 0 ? (
            <div className="partners">
              <div className="container">
                <div className="partners__body">
                  {partnersWidget.data.sort((a, b) => a.order - b.order).map((item, index) => (
                    <div className="partners__item" key={index}>
                      <img className="partners__image" src={item.img_desktop} alt="partners image"/>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ) : null)}
          <Tabs tabs={tabsShortInsuranceInfo} toggle={this.toggleShortInsuranceInfoTab} tab={this.state.tabShortInsuranceInfo} page={page} title={'MINI_CASCO_NEW_TABS_TITLE'}>
            {detailedInsuranceInfoWidgets.map(({widget, loadingKey}, index) => {
              const detailedInfoTariffsItems = mapInsuranceDetailedInfoToTariffs(widget);

              if (this.state[loadingKey]) {
                return canUseDOM ? <Preloader key={index}/> : null;
              }

              if (detailedInfoTariffsItems && detailedInfoTariffsItems.length > 0) {
                return (
                  <Tariffs
                    key={index}
                    items={detailedInfoTariffsItems}
                    alignItems="start"
                    onBtnClick={this.toggleDetailedInsuranceInfoTab}
                    btnText={'MINI_CASCO_NEW_TARIFFS_INSURANCE_INFO_BTN'}
                    insuranceInfo
                    btnId={'insurance-info'}
                    page={page}
                  />
                );
              }

              return null;
            })}
          </Tabs>
          <Tariffs
            items={intermediaryTariffsData}
            title={'MINI_CASCO_NEW_TARIFFS_INTERMEDIARY_INFO_TITLE'}
            alignItems="start"
            onBtnClick={this.toggleIntermediaryInsuranceInfoTab}
            btnText={'MINI_CASCO_NEW_TARIFFS_INTERMEDIARY_INFO_BTN'}
            btnId={'intermediary'}
            page={page}
          />
        </Tabs>
        <AdditionalProduct
          items={additionalCards}
          title={'MINI_CASCO_NEW_ADDITIONAL_PRODUCT_TITLE'}
          page={page}
        />
        <QuestionsAdminNew
          page={page}
          widget={questionsWidget}
          toggleFaqTab={this.toggleFaqTab}
          title={'MINI_CASCO_NEW_QUESTIONS_TITLE'}
          loader={this.state.loader}
        />
      </div>
      <div className={`content${!this.state.faqTab ? ' hidden' : ''}`}>
        <FAQStorybook
          widget={questionsWidget}
          title={this.l10n('MINI_CASCO_NEW_FAQ_STORYBOOK_TITLE')}
          btnText={this.l10n('MINI_CASCO_NEW_FAQ_STORYBOOK_BTN_TEXT')}
          onBtnClick={this.toggleFaqTab}
          filterByEnvironment={filterByEnvironment}
        />
      </div>
      <div className={`content${!this.state.detailedInsuranceInfoTab ? ' hidden' : ''}`}>
        <div>
          <div className="insurance-detailed-info">
            <div className="container">
              <div className="insurance-detailed-info__top">
                <h2 className="insurance-detailed-info__title">{this.l10n('MINI_CASCO_NEW_DETAILED_INFO_TITLE')}</h2>
                <button className="insurance-detailed-info__btn" onClick={this.toggleDetailedInsuranceInfoTab}>{this.l10n('MINI_CASCO_NEW_DETAILED_INFO_BTN')}</button>
              </div>
            </div>
          </div>
          <Tabs tabs={tabsFullInsuranceInfo} toggle={this.toggleFullInsuranceInfoTab} tab={this.state.tabFullInsuranceInfo}>
            {detailedInsuranceInfoWidgets.map(({widget}, index) => (
              <QuestionsFullAdmin
                key={index}
                widget={widget}
              />
            ))}
          </Tabs>
        </div>
      </div>
      <div className={`content${!this.state.intermediaryInsuranceInfoTab ? ' hidden' : ''}`}>
        <InsuranceIntermediaryInfo
          items={intermediaryInfoData}
          title={'MINI_CASCO_NEW_INTERMEDIARY_INFO_TITLE'}
          onBtnClick={this.toggleIntermediaryInsuranceInfoTab}
          btnText={'MINI_CASCO_NEW_INTERMEDIARY_INFO_BTN'}
        />
      </div>
    </div>
  )
}
